import * as Api from '@ViewModels';
import { MEETING_STATUS_CONFIG } from '../../../components/dataBoards/meetings/utils';

/** Accent/label for a meeting status, reusing the Meetings data board's shared config. */
export function getMeetingStatusDisplay(status?: Api.MeetingStatus): { label: string; color: string } {
	if (status && MEETING_STATUS_CONFIG[status]) {
		return MEETING_STATUS_CONFIG[status];
	}
	return { label: 'Scheduled', color: MEETING_STATUS_CONFIG[Api.MeetingStatus.Scheduled].color };
}

/** Whether a meeting should render with muted/struck-through styling. */
export function isMeetingCancelled(meeting: Api.IScheduledMeeting): boolean {
	return meeting.status === Api.MeetingStatus.Cancelled;
}
